import React, { useEffect, useState, useRef } from 'react';
import Button from '../form-elements/Button';
import { Dropdown } from '../Dropdown/Dropdown';
import loadable from '@loadable/component';
import { useSelector } from 'react-redux';
import _ from 'lodash';

const VehicleSelectionPanel = loadable(() => import('./VehicleSelectionPanel'));

function VehicleSelectionToggle() {
    const [isVisible, setIsVisible] = useState(false);
    const [isSelected, setIsSelected] = useState(false);
    const [triggerMode, setTriggerMode] = useState('hover');
    const lastInputType = useRef('mouse');

    const vehicle = useSelector(state => state.vehicle);

    const checkIfSelected = (vehicle) => {
        return !_.isEmpty(vehicle.label) && !_.isEmpty(vehicle.datECodePrefix);
    };

    useEffect(() => {
        setIsSelected(checkIfSelected(vehicle));
    }, [vehicle]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Tab") {
                lastInputType.current = 'keyboard';
                setTriggerMode('click');
            }
        };
        const handleMouseDown = () => {
            lastInputType.current = 'mouse';
            setTriggerMode('hover');
        };
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('mousedown', handleMouseDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);

    const handleBlur = () => {
        setTriggerMode('hover');
    };

    return (
        <Dropdown
            isVisible={isVisible}
            onIsVisibleChange={isVisible => setIsVisible(isVisible)}
            className="uk-card uk-card-default uk-card-small"
            boundary=".vehicle-selection-dropdown-boundary"
            pos="bottom-right"
            boundaryAlign
            mode={triggerMode} // hover or click
            toggleElement={
                <Button
                    modifier="link"
                    onClick={() => {}}
                    onBlur={handleBlur}
                    ariaLabel={isVisible ? "Fahrzeugauswahl" : isSelected ? "Fahrzeug ausgewählt" : "Fahrzeug auswählen"}
                >
                    {isVisible ? (
                        <i className="fa fa-car fa-2x" aria-hidden="true" />
                    ) : isSelected ? (
                        <>
                            <i className="uk-position-absolute fa fa-check fa-2x" style={{ top: -12, right: -12, color: "var(--shop-main)" }} aria-hidden="true"></i>
                            <i className="fa fa-car fa-2x" aria-hidden="true"/>
                        </>
                    ) : (
                        <>
                            <span className="uk-badge uk-position-absolute" style={{ height: 20, minWidth: 20, top: -8, right: -8 }} aria-hidden="true"></span>
                            <i className="fa fa-car fa-2x" aria-hidden="true"/>
                        </>
                    )}
                </Button>
            }
            placeholderChildren={<div style={{ minWidth: 240, height: 10 }} />}
        >
            <VehicleSelectionPanel />
        </Dropdown>
    );
}

export default VehicleSelectionToggle;
